module.exports = __webpack_public_path__ + "static/img/040_9.d4c6a62.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/pages/home/img/040_9.jpg
// module id = fN8T
// module chunks = 1